import React, { useState } from "react";
import "./LandingPage.css";

function LandingPage() {
  const [showApp, setShowApp] = useState(false);

  const handleEnterApp = () => {
    const password = prompt("Masukkan password untuk akses aplikasi pribadi:");
    if (password === "12345") { // ganti dengan passwordmu
      window.location.href = "/app"; // arahkan ke aplikasi pribadi
    } else {
      alert("Password salah!");
    }
  };

  const handleOpenHelpdesk = () => {
  window.location.href = "https://bit.ly/GKNManado";
};


  const handleOpenGAS = () => {
    window.location.href =
      "https://script.google.com/macros/s/AKfycbywr5lEGYAmD89EbwxU0bErTSGH9BTeMYNayGmVwf8mCc1t8D4PU1ev3a9GFLuBzcn33g/exec";
  };

  return (
    <div className="container">
      {!showApp ? (
        <div className="landing-box">
          <div className="tittleWraper">
          <h3 className="title">Selamat Datang di </h3>
          <h1>Nganaqta</h1>
          </div>
          <p className="subtitle">Platform direct link internal.</p>
          
          <div className="button-group">
            <a
              onClick={handleOpenGAS}
              target="_blank"
              rel="noopener noreferrer"
              className="button-secondary"
            >
              Web Cuti 🌐
            </a>
              <button className="button-secondary" onClick={handleOpenHelpdesk}>
            HD 💬
          </button>
          </div>

          <footer className="footer">© 2026 Nganaqta.</footer>

          <button className="button-primary" onClick={handleEnterApp}>
            Admin
          </button>
        </div>
      ) : (
        <div className="app-content">
          <h2>🚀 Aplikasi Pribadi</h2>
          <p>Hore, kamu berhasil masuk!</p>
        </div>
      )}
    </div>
  );
}

export default LandingPage;
